export default __webpack_public_path__ + "static/media/Our_Song.896d1326.mp3";